import React from "react";

interface TabItemProps {
  value: string;
  label: string;
  activeValue?: string;
  onClick?: (tabValue: string) => void;
  textColor?: string;
  indicatorColor?: string;
}

export function TabItem({ label, value, activeValue, onClick, textColor, indicatorColor }: TabItemProps) {
  return (
    <div className="flex flex-col cursor-pointer" onClick={() => onClick && onClick(value)}>
      <h3 className={`text-sm ${activeValue === value ? `${indicatorColor} font-semibold` : textColor} underline underline-offset-2`}>{label}</h3>
    </div>
  );
}
